import { Link } from '@tanstack/react-router'
import { ClipboardList } from 'lucide-react'
import { buttonVariants } from '@/components/ui/button'

/** Opens the prep modal over the current tab by setting the dashboard's `prep` flag, so the link can be shared. */
export function PrepareMeetingLink({ size = 'sm' }: { size?: 'sm' | 'xs' }) {
  return (
    <Link to={'.' as never} search={((previous: Record<string, unknown>) => ({ ...previous, prep: true })) as never} className={buttonVariants({ size })}>
      <ClipboardList />
      Prepare meeting
    </Link>
  )
}
